/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSettingDefinitionFromJSON(json) {
    return StreemApiSettingDefinitionFromJSONTyped(json, false);
}
export function StreemApiSettingDefinitionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        '_default': !exists(json, 'default') ? undefined : json['default'],
        'publicRead': !exists(json, 'public_read') ? undefined : json['public_read'],
        'companyWrite': !exists(json, 'company_write') ? undefined : json['company_write'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'modifiedAt': !exists(json, 'modified_at') ? undefined : (new Date(json['modified_at'])),
    };
}
export function StreemApiSettingDefinitionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'type': value.type,
        'default': value._default,
        'public_read': value.publicRead,
        'company_write': value.companyWrite,
        'scope': value.scope,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'modified_at': value.modifiedAt === undefined ? undefined : (value.modifiedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiSettingDefinitionType;
(function (StreemApiSettingDefinitionType) {
    StreemApiSettingDefinitionType["BOOLEAN"] = "TYPE_BOOLEAN";
    StreemApiSettingDefinitionType["DOUBLE"] = "TYPE_DOUBLE";
    StreemApiSettingDefinitionType["INTEGER"] = "TYPE_INTEGER";
    StreemApiSettingDefinitionType["INVALID"] = "TYPE_INVALID";
    StreemApiSettingDefinitionType["STRING"] = "TYPE_STRING";
})(StreemApiSettingDefinitionType || (StreemApiSettingDefinitionType = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiSettingDefinitionScope;
(function (StreemApiSettingDefinitionScope) {
    StreemApiSettingDefinitionScope["INTERNAL"] = "SCOPE_INTERNAL";
    StreemApiSettingDefinitionScope["INVALID"] = "SCOPE_INVALID";
    StreemApiSettingDefinitionScope["LICENSE"] = "SCOPE_LICENSE";
    StreemApiSettingDefinitionScope["PLATFORM"] = "SCOPE_PLATFORM";
})(StreemApiSettingDefinitionScope || (StreemApiSettingDefinitionScope = {}));
//# sourceMappingURL=StreemApiSettingDefinition.js.map